import React from "react"
import styled from "styled-components"
import { DropdownSection, DropdownList, DropdownItem, Label } from "./Components"

import ComplianceLogo from '../svg/Compliance'
import SecurityLogo from '../svg/Security'

const ProductsDropdownEl = styled.div`
  width: 392px;
`

const ProductsSection = styled.ul`
  padding: 0;
`

const ProductsDropdown = () => {
  return (
    <ProductsDropdownEl>
      <DropdownSection data-first-dropdown-section>
        <ProductsSection>
          <DropdownItem
            logo={<ComplianceLogo size={48} />}
            title="Licensing & Compliance"
            description="Compliance at every commit"
            href="/features"
            color="blue"
          />
          <DropdownItem
            logo={<SecurityLogo size={48} />}
            title="Security"
            description="Automatically secure your dependencies"
            href="/vulnerability-scanning"
            color="green"
          />
        </ProductsSection>
      </DropdownSection>
      <DropdownSection>
        <DropdownList>
          <li>
            <Label>Use Cases</Label>
          </li>
          <li>
            <a href="/solutions/open-source-programs-office/">Open Source Program Office</a>
          </li>
          <li>
            <a href="/solutions/legal/">Compliance for Legal Teams</a>
          </li>
          <li>
            <a href="https://demand.fossa.com/request-audit?source=Website" target="_blank">Due Diligence Audit</a>
          </li>
        </DropdownList>
      </DropdownSection>
    </ProductsDropdownEl>
  )
}

export default ProductsDropdown
